document.addEventListener('DOMContentLoaded', function() {
    function adjustImageWidth() {
      const mediaContainers = document.querySelectorAll('.disclosure__image-container .media');
      
      if (mediaContainers.length === 0) return;
      
      const screenWidth = window.innerWidth;
      
      if (screenWidth < 420) {
        mediaContainers.forEach(container => {
          const originalStyle = container.getAttribute('style');
          if (!originalStyle || !originalStyle.includes('width:')) return;
          
          const widthMatch = originalStyle.match(/width:\s*(\d+)px/);
          if (!widthMatch || widthMatch.length < 2) return;
          
          const originalWidth = parseInt(widthMatch[1], 10);
          const reducedWidth = Math.round(originalWidth * 0.8);
          
          container.style.width = `${reducedWidth}px`;
        });
      } else {
        mediaContainers.forEach(container => {
        });
      }
    }
    
    adjustImageWidth();
    
    window.addEventListener('resize', adjustImageWidth);
  });
  